export default __webpack_public_path__ + "images/12de1e78e7bf4ea5efc71256c37fe3f3.svg";